/* components/Masonry
- Used to display a masonry grid of items

Example
<masonry>
    [[collection or group of content]]
</masonry>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class MasonryGrid extends ThemeComponent {

}
